import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { FC } from 'react';
import { AlertCircle } from 'react-ionicons';

interface UploadErrorProps {
  onClear: () => void;
}

const UploadError: FC<UploadErrorProps> = ({ onClear }) => {
  return (
    <>
      <span className="text-status-error-default">
        <AlertCircle width="24px" height="24px" color="currentColor" />
      </span>
      <p className="mb-4 mt-2 text-center text-xs font-bold text-content-base-default">
        The file to upload must be in PNG, SVG or JPG format.
      </p>
      <GraniteButton size="small" variant="secondary" onClick={onClear}>
        Try again
      </GraniteButton>
    </>
  );
};

export default UploadError;
